import type { SerializedModelPayload } from '~/shared/interfaces'
import { isUnknownObject } from '~/shared/utils/guards'
import type { ModelConstructor } from './base'

const modelRegistry = new Map<string, ModelConstructor>()

export function registerModel<T extends ModelConstructor>(modelCtor: T): T {
  if (!modelCtor.constructorName) {
    throw new Error(`[modelRegistry] ${modelCtor.name} не объявляет static constructorName`)
  }

  modelRegistry.set(modelCtor.constructorName, modelCtor)
  return modelCtor
}

export function reviveModel(payload: unknown): unknown {
  if (!isSerializedModelPayload(payload)) {
    return payload
  }

  const modelCtor = modelRegistry.get(payload.constructorName)
  if (!modelCtor) {
    if (import.meta.dev) {
      console.warn(
        `[modelRegistry] Модель "${payload.constructorName}" не зарегистрирована: `
        + 'из SSR payload восстановлен обычный объект вместо экземпляра класса.'
      )
    }
    return payload.data
  }

  return new modelCtor(payload.data)
}

function isSerializedModelPayload(payload: unknown): payload is SerializedModelPayload {
  return (
    isUnknownObject(payload) &&
    typeof payload.constructorName === 'string' &&
    isUnknownObject(payload.data)
  )
}
